import { Component, OnInit } from '@angular/core';
import { TalentService } from 'src/app/providers/talent/talent.service';

@Component({
  selector: 'app-minimumwage',
  templateUrl: './minimumwage.component.html',
  styleUrls: ['./minimumwage.component.scss']
})
export class MinimumwageComponent implements OnInit {
  sallaryStructure: any = [];
  sallaryStructureBackup: any = [];
  finalTotal: any  = '';
  grossTotal: any  = '';
  candID: any  = 2;
  finalTotalBackup = 0;
  pfType: any  = 151;  // 150(SA) | 157(SA) | 151 (OA)
  min: any = 0;
  basic: any  = 0;
  da: any  = 0;
  hra: any  = 0;
  siteAllow: any  = 0;
  otherAllow: any  = 0;
  public pfTypeCompID: any = 0;
  basicBackup: any;
  daBackup: any;
  hraBackup: any;
  siteAllowBackup: any;
  otherAllowBackup: any;

  basicMin: any;
  daMin: any;
  hraMin: any;
  siteAllowMin: any;
  otherAllowMin: any;
  percentageCheck  = false;
  percentageCheckValue  = 0;

  constructor(
    private talentService: TalentService,
  ) { }

  ngOnInit(): void {
    this.getCandPayrollStructure();
  }
  changeFivePercent(): void {
    this.percentageCheck = this.percentageCheckValue == 1 ? true : false;
  }
  findWithAttr(array, attr, value): number {
      for(var i = 0; i < array.length; i += 1) {
          if(array[i][attr] === value) {
              return i;
          }
      }
      return -1;
  }
  calculateTotal(): void {
    let final_sum = 0;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.sallaryStructure.length; i++) {
      let element = this.sallaryStructure[i];
      if(element.comp_value == '' || element.comp_value == null || element.comp_value == undefined){
        continue;
      }
      element.comp_value =  parseFloat(element.comp_value);
      if(element.comp_id != 22 && element.comp_value!='' && element.comp_value!=null && element.comp_value!=undefined){
        final_sum += element.comp_value;
      }
    }
    try{
      this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 22)].comp_value = final_sum;
    }catch(err){

    }

  }
  getTotal(): number {
    const basic = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
    const da = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
    const hra = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
    const oa = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
    const sa = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
    let total = 0;
    if(this.pfType == 151){
      const oa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
      total = basic + da;// + hra + oa;
    }else{
      const sa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
      total = basic + da;// + hra + sa;
    }
    return total;
  }
  balanceHraCheck(): boolean {
    if (this.pfType == 151){
      this.pfTypeCompID = 21;
    }else{
      this.pfTypeCompID = 5;
    }
    const basic = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
    const da = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
    const hra = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
    let total = 0;
    if(this.pfType == 151){
      const oa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
      total = basic + da + hra + oa;
    }else{
      const sa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
      total = basic + da + hra + sa;
    }

    console.log('total', total);
    // const da  = this.da;
    // const hra  = this.hra;
    let per05 = basic + da;
    per05 =    per05*0.05;
    console.log('basic', basic);
    console.log('da', da);
    console.log('hra', hra);
    console.log('per05', per05);
    let bas_da = basic + da;
    let diff = this.grossTotal - bas_da;
    console.log('diff', diff);
    // let lastCom = 0;
    let newHRA = 0;
    if(diff < per05){
        console.log('diff < per05', diff < per05);
        newHRA = diff;

      }else{
        console.log('diff > per05', diff > per05);
        newHRA  = diff - per05;
    }
    console.log('Nre HRA',newHRA);
    if(newHRA > per05){
      return true;
    }else{
      return false;
    }
  }
  balanceHraTest() {
      if (this.pfType == 151){
        this.pfTypeCompID = 21;
      }else{
          this.pfTypeCompID = 5;
      }
      const basic = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
      const da = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
      const hra = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
      let total = 0;
      if(this.pfType == 151){
        const oa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
        total = basic + da + hra + oa;
      }else{
        const sa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
        total = basic + da + hra + sa;
      }

      // console.log('total', total);
      // const da  = this.da;
      // const hra  = this.hra;
      let per50 = basic + da;
      per50 =    per50*0.5;
      // console.log('basic', basic);
      // console.log('da', da);
      // console.log('hra', hra);
      // console.log('per50', per50);
      let bas_da = basic + da;
      let diff = this.grossTotal - bas_da;
      // console.log('diff', diff);
      let lastCom = 0;
      if(diff < per50){
          // console.log('diff < per50', diff < per50);
          if(diff < 0){
            return false;
          }

        }else{

      }
      return true;

  }
  balanceHra(): void {
      if (this.pfType == 151){
          this.pfTypeCompID = 21;
      }else{
          this.pfTypeCompID = 5;
      }
      const basic = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
      const da = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
      const hra = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;
      let total = 0;
      if(this.pfType == 151){
        const oa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
        total = basic + da + hra + oa;
      }else{
        const sa  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
        total = basic + da + hra + sa;
      }

      console.log('total', total);
      // const da  = this.da;
      // const hra  = this.hra;
      let per50 = basic + da;
      per50 =    per50*0.5;
      console.log('basic', basic);
      console.log('da', da);
      console.log('hra', hra);
      console.log('per50', per50);
      let bas_da = basic + da;
      let diff = this.grossTotal - bas_da;
      console.log('diff', diff);
      let lastCom = 0;
      if(diff < per50){
          console.log('diff < per50', diff < per50);
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value = diff;
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', this.pfTypeCompID)].comp_value = 0;
        }else{
          console.log('diff > per50', diff > per50);
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value = per50;
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', this.pfTypeCompID)].comp_value = diff - per50;
          lastCom = diff - per50;
      }
      this.basicBackup = basic;
      this.daBackup = da;
      this.hraBackup = hra;
      if (this.pfType == 151){
        this.otherAllowBackup = lastCom;
      }else{
        this.siteAllowBackup = lastCom;
      }
      this.finalTotalBackup =  this.grossTotal;

  }
  changeValueTotal(event,comp,index) {
    if (event.which === 101 || event.which === 43 || event.which === 45) {
        console.log('e error');
        return false;
    }
    // event.target.value =  parseFloat(event.target.value);
    console.log('index',index);

    if(comp == '0'){
        console.log('0 ----',comp);
        if(this.grossTotal == '' ||  this.grossTotal == null || this.grossTotal == undefined){
          this.grossTotal = this.finalTotalBackup;
          return;
        }
        if(this.grossTotal < this.finalTotalBackup){
          this.grossTotal = this.finalTotalBackup;
          return;
        }
        // if(this.percentageCheck == true) {
        //   if(this.balanceHraCheck() ==  false){
        //     this.grossTotal = this.finalTotalBackup;
        //     return;
        //   }
        // }
    }
    if(comp == 1){
      console.log('2 + ',comp);
      if(event.target.value == '' ||  event.target.value == null || event.target.value == undefined){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.basicBackup;
        return;
      }
      if(event.target.value < this.basicMin){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.basicBackup;
        return;
      }

      // let total = this.getTotal();
      // if(this.grossTotal < total){
      //   this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.basicBackup;
      //   return;
      // }

      if(this.percentageCheck == true) {
        if(this.balanceHraCheck() ==  false){
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.basicBackup;
          return;
        }
      }


      let res = this.balanceHraTest();
      if(res ==  false){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.basicBackup;
        return;
      }



    }
    if(comp == 2){
      console.log('3 = ',comp);
      if(event.target.value == '' ||  event.target.value == null || event.target.value == undefined){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.daBackup;
        return;
      }
      if(event.target.value < this.daMin){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.daBackup;
        return;
      }
      // let total = this.getTotal();
      // if(this.grossTotal < total){
      //   this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.daBackup;
      //   return;
      // }
      if(this.percentageCheck == true) {
        if(this.balanceHraCheck() ==  false){
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.daBackup;
          return;
        }
      }
      let res = this.balanceHraTest();
      if(res ==  false){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.daBackup;
        return;
      }
    }
    if(comp == 3){
      console.log('4 = ',comp);
      if(event.target.value == '' ||  event.target.value == null || event.target.value == undefined){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.hraBackup;
        return;
      }
      if(event.target.value < this.hraMin){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.hraBackup;
        return;
      }
      // let total = this.getTotal();
      // if(this.grossTotal < total){
      //   this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.hraBackup;
      //   return;
      // }
      if(this.percentageCheck == true) {
        if(this.balanceHraCheck() ==  false){
          this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.hraBackup;
          return;
        }
      }

      let res = this.balanceHraTest();
      if(res ==  false){
        this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', comp)].comp_value = this.hraBackup;
        return;
      }
    }


    this.balanceHra();
    this.calculateTotal();
  }
  changeValue(event,list,index) {
    if (event.which === 101 || event.which === 43 || event.which === 45) {
       return false;
    }

    if (list.is_gross == 0){
        this.calculateTotal();
    }
    if (list.is_gross == 1){

    }
  }

  getCandPayrollStructure(): void {
    this.talentService.getCandPayrollStructure(this.candID,'cand').subscribe(res => {
      this.sallaryStructure = res;

      if(this.pfType == 151){
        this.sallaryStructure = this.sallaryStructure.data.filter((el) => {
          return el.comp_id != 5;
        });
      }else{
        this.sallaryStructure = this.sallaryStructure.data.filter((el) => {
          return el.comp_id != 21;
        });
      }
      this.sallaryStructureBackup = this.sallaryStructure;
      setTimeout(() => {
        this.finalTotal =  this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 22)].comp_value;
        this.basic  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
        this.da  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
        this.hra  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;

        this.basicBackup  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
        this.daBackup  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
        this.hraBackup  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;

        this.basicMin  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 1)].comp_value;
        this.daMin  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 2)].comp_value;
        this.hraMin  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 3)].comp_value;



        if(this.pfType == 151){
          this.otherAllow  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
          this.otherAllowBackup  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
          this.otherAllowMin  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 21)].comp_value;
        }else{
          this.siteAllow  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
          this.siteAllowBackup  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
          this.siteAllowMin  = this.sallaryStructure[this.findWithAttr(this.sallaryStructure, 'comp_id', 5)].comp_value;
        }
        this.finalTotalBackup = this.finalTotal;
        this.grossTotal = this.finalTotal;
      }, 2000);
    }, err => {
      this.getCandPayrollStructure();
    });
  }
  loadReset(): void {
      this.getCandPayrollStructure();
  }
}
